import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const selfCheckStatus = z.object({
  serialNumber: z.number(),
  failed: z.boolean().optional().default(false),
  finishedAt: z.date().default(() => new Date()),
  results: z.string().optional(),
});

export class SelfCheckStatus extends createZodDto(selfCheckStatus) {}
